<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>location_city</mat-icon>
      Branch event
      @if (loading) {
        <mat-icon class="loading">autorenew</mat-icon>
      }
    </h1>
  </section>
  <section mat-dialog-content>
    @if (!loading) {
      <div>
        <h2>Is this a {{branch.name}} event?</h2>
      </div>
    }
  </section>
  @if (!loading) {
    <section align="end" mat-dialog-actions>
      <button (click)="selectBranch('notBranchEvent')" mat-button>
        <mat-icon>event_busy</mat-icon>
        Not a branch event
      </button>
      <button (click)="selectBranch()" mat-button>
        <mat-icon>event</mat-icon>
        Create branch event
      </button>
    </section>
  }
</section>
